import {floor} from 'lodash';

export const parseNumberToCurrency = (
  amount: number,
  minimumFractionDigits = 2,
  prefix: string = '',
  integerWithoutDecimals = false,
) => {
  const value = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits:
      amount === floor(amount) && integerWithoutDecimals
        ? 0
        : minimumFractionDigits,
  }).format(amount);

  return `${prefix}${value}`;
};

export const parseNumberToCurrencyCents = ({
  amountInCents,
  minimumFractionDigits = 2,
  prefix = '',
  integerWithoutDecimals = false,
  currency = 'USD',
}: {
  amountInCents: number;
  minimumFractionDigits?: number;
  prefix?: string;
  integerWithoutDecimals?: boolean;
  currency?: string;
}) => {
  const value = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits:
      amountInCents === floor(amountInCents) && integerWithoutDecimals
        ? 0
        : minimumFractionDigits,
  }).format(amountInCents / 100);

  return `${prefix}${value}`;
};
